var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.240234,
    width: 23.7037,
    height: 24,
    fill: "url(#pattern0_3_913)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_913",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_913",
    transform: "scale(0.0125 0.0123457)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_913",
    width: 80,
    height: 81,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALTSURBVHgB7dlBchJBFMbx12OyYCVHGKP7kBuEG8iGCCwkJ1BPYLyBnkBcGKqIVXgD9ATiAbTmCLhCS5i2H2yihqF5M91DD99vlUp1hZp/9WSYfkQAAAAAAAAAAAAAAADVp+gAxcNxHKnFM9KqrtL087dee0BCBxcwfj9qmIuemCuv3/r1VNeOm0mrNaMdRXRANsRjjWj+q08CBxOQb1ulaHxHvDUVnZLAQQRcxdO/J/zjxkWafpBA5QNaxpulavmaBCr9ELGKZ2hNZ0mvPSWByu7AHeJdSuOxSu7AHeMNKIfK7cB4PK6beGPaFo/SF3njsUoFXMWbr3ZeI2ud1vpV0n0iemj8q1IB1c8F77zt8XoXV1SQygQ8GY7emjrnWWuKjscq8RDheOaB0M9a4yIeC34HngxvXpYVjwW9A9fx9FXWGk36XdK96JMjwQbch3gsyIA28cyFffzebbfIseD+B9rEM6Zp7fiSPAhqB9rGk54uSwQT8OH1h6cppYMtyxIT78xXPBbELWwdTy2bPuOxvd+Bj4Y350utJ1uWreN1Ogl5ttcBM4ZAt5UWj+1twBDiMXFAPjqK5os+KXVKSs9SffQm6bQSKoDlgWjp8Zg44IPr0Rf6++hopo+ombTlx+PMdgikyXxWL99nFUH0FDa3V5/+P3erqwVN4tGoQUKhxWOigEptPHcTR7SeY+xRPCYLqFXWd62dI/qaoLkgCphGZghtbqWMJdYRfU7QXBAF5Ccf30p5I/qeoLkgfpXjWylPxDImaC7kehfOE7GMCZoLuQ8TJBHLmqC5UNirnOWr18ys+WSCP876W6HEY4W+C1tGzBRSPFb4YUKeiD6GQEVzchojiRhiPObsOGuXiL4maC44O9K3fDozbxM0F5wfqG7ZiV4naC54OZHeENH7BM0Fb0f68XAYR/rec1LRffNd5WtaOxqEHg8AAAAAAAAAAAAAdvAH3avH+PVne7AAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTick);
export default __webpack_public_path__ + "static/media/progressTick.c890753fe05b92653b9603171f69fce8.svg";
export { ForwardRef as ReactComponent };